document.addEventListener("DOMContentLoaded", function () {

    const items = document.querySelectorAll('li[class*="header-color-"]');

    items.forEach(li => {

        const colorClass = [...li.classList].find(c => c.startsWith("header-color-"));
        if (!colorClass) return;

        // Extraire la valeur (046bd2)
        const hex = colorClass.replace("header-color-", "");

        // Ajouter la variable CSS à <li>
        li.style.setProperty("--header-color", "#" + hex);
    });
});
